export default "__VITE_ASSET__BdDA$U_k__"